import React, {useCallback} from 'react';
import styles from './InfoPanel.module.scss'
import {Button} from "presentation/common";
import clsx from "clsx";
import {useHistory} from 'react-router-dom';
import AppRouters from "application/globals/app-routers";

export const InfoPanel = (props) => {
  const history = useHistory();
  const newRequest = useCallback(
    () => {
      history.push(AppRouters.newReport)
    },
    [history],
  );

  return (
    <div className={styles.container}>
      <div className={clsx("flex flex-col", styles.firstPanel)}>
        <p className={clsx(styles.subTitle, 'mb-3')}>¡Ahorra tiempo y esfuerzo!</p>
        <p className={clsx(styles.title, "mb-8 mr-2")}>
          Solicita tu Cotización Personalizada
        </p>
        <Button label="Solicitar" className={styles.btn} onClick={newRequest}/>
      </div>
      <div className={clsx("flex flex-col", styles.secondPanel)}>
        <p className={styles.bigTitle}>Ahora puedes</p>
        <p className={styles.subTitle}>Inscribir tu vehículo de manera online</p>
        <p className={styles.description}>
          Solicita la cotización personalizada de tu vehículo. Te mostraremos los planes que ofertamos para que escojas
          el que se ajuste a tus necesidades.
        </p>
        <Button label="Solicitar" className={styles.btn} onClick={newRequest}/>
      </div>
    </div>
  );
};

InfoPanel.propTypes = {}

InfoPanel.defaultProps = {}

export default React.memo(InfoPanel);
